import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "primary-gradient-bg text-center my-5 py-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "py-4" })
], -1)
const _hoisted_3 = { class: "pb-5 contact-bg" }
const _hoisted_4 = { class: "container container-fluid" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  class: "col-md-6 offset-md-3 bg-white px-5 py-4 border rounded-2",
  style: {"margin-top":"-100px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-center mb-4" }, "Send us a message", -1)
const _hoisted_8 = { class: "col-md-10 mb-5" }
const _hoisted_9 = { class: "w-100 text-center" }
const _hoisted_10 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Send ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_Form, { onSubmit: _ctx.onSubmit }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Field, {
                    name: "full_name",
                    rules: { required: true},
                    modelValue: _ctx.contact_details.full_name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contact_details.full_name) = $event))
                  }, {
                    default: _withCtx(({ field, meta }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-group mb-4", meta.validated && !meta.valid && !_ctx.submited ? 'has-error border-danger' : ''])
                      }, [
                        _createElementVNode("input", _mergeProps(field, {
                          type: "text",
                          id: "full_name",
                          placeholder: "Full Name",
                          class: "form-control material-control",
                          autocomplete: "off"
                        }), null, 16),
                        (!_ctx.submited)
                          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                              key: 0,
                              class: "text-danger",
                              name: "full_name"
                            }))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_Field, {
                    name: "email",
                    rules: { required: true, email: true },
                    modelValue: _ctx.contact_details.email,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contact_details.email) = $event))
                  }, {
                    default: _withCtx(({ field, meta }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-group mb-4", meta.validated && !meta.valid && !_ctx.submited  ? 'has-error border-danger' : ''])
                      }, [
                        _createElementVNode("input", _mergeProps(field, {
                          type: "text",
                          id: "email",
                          placeholder: "Email Address",
                          class: "form-control material-control",
                          autocomplete: "off"
                        }), null, 16),
                        (!_ctx.submited)
                          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                              key: 0,
                              class: "text-danger",
                              name: "email"
                            }))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_Field, {
                    name: "message",
                    rules: { required: true },
                    modelValue: _ctx.contact_details.message,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contact_details.message) = $event))
                  }, {
                    default: _withCtx(({ field, meta }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-group mb-4", meta.validated && !meta.valid && !_ctx.submited ? 'has-error border-danger' : ''])
                      }, [
                        _createElementVNode("textarea", _mergeProps(field, {
                          id: "message",
                          placeholder: "Message",
                          class: "form-control material-control",
                          row: "3"
                        }), "\n                            ", 16),
                        (!_ctx.submited)
                          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                              key: 0,
                              class: "text-danger",
                              name: "message"
                            }))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-sm rounded-5 px-5 me-2 fw-bold",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submited = false))
                  }, [
                    (_ctx.sending)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_11
                        ], 64))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}